var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.35C3.07664 14.6551 0.5 11.6284 0.5 8C0.5 3.85787 3.85786 0.5 8 0.5C11.6284 0.5 14.6551 3.07664 15.35 6.5H28.65C29.3449 3.07664 32.3716 0.5 36 0.5C40.1421 0.5 43.5 3.85787 43.5 8C43.5 11.6284 40.9234 14.6551 37.5 15.35V28.65C40.9234 29.3449 43.5 32.3716 43.5 36C43.5 40.1421 40.1421 43.5 36 43.5C32.3716 43.5 29.3449 40.9234 28.65 37.5H15.35C14.6551 40.9234 11.6284 43.5 8 43.5C3.85786 43.5 0.5 40.1421 0.5 36C0.5 32.3716 3.07664 29.3449 6.5 28.65L6.5 15.35ZM3.5 8C3.5 5.51472 5.51472 3.5 8 3.5C10.4853 3.5 12.5 5.51472 12.5 8C12.5 10.4853 10.4853 12.5 8 12.5C5.51472 12.5 3.5 10.4853 3.5 8ZM9.5 28.65L9.5 15.35C12.4387 14.7535 14.7534 12.4387 15.35 9.5H28.65C29.2466 12.4387 31.5613 14.7535 34.5 15.35V28.65C31.5613 29.2465 29.2466 31.5613 28.65 34.5H15.35C14.7534 31.5613 12.4387 29.2465 9.5 28.65ZM8 31.5C5.51472 31.5 3.5 33.5147 3.5 36C3.5 38.4853 5.51472 40.5 8 40.5C10.4853 40.5 12.5 38.4853 12.5 36C12.5 33.5147 10.4853 31.5 8 31.5ZM40.5 8C40.5 10.4853 38.4853 12.5 36 12.5C33.5147 12.5 31.5 10.4853 31.5 8C31.5 5.51472 33.5147 3.5 36 3.5C38.4853 3.5 40.5 5.51472 40.5 8ZM31.5 36C31.5 33.5147 33.5147 31.5 36 31.5C38.4853 31.5 40.5 33.5147 40.5 36C40.5 38.4853 38.4853 40.5 36 40.5C33.5147 40.5 31.5 38.4853 31.5 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/Cluster.a0b9747c17985de7cab86b18a1cdb239.svg";
export { ForwardRef as ReactComponent };